import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppWrapper from './App';
import { setupGlobalErrorHandling } from './utils/errorHandling';
import { initSentry } from './lib/sentry';
import { initializeLoadingScreen } from './hooks/useInitialLoadingScreenManager';
import './index.css';

try {
  // Initialize Sentry
  initSentry(import.meta.env.VITE_SENTRY_DSN || '');
  // Set up global error handlers
  setupGlobalErrorHandling();
  // Initialize loading screen
  initializeLoadingScreen();
} catch (error) {
  console.warn('Error during basic initialization:', error);
}

// Simple app initialization
(async function () {
  try {
    // Render the React application
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error('Root element not found for app rendering');
    }

    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <AppWrapper />
      </StrictMode>
    );
  } catch (error) {
    console.error('Critical error during application initialization:', error);
  }
})();
